import {
	SIGNOFF_ALT_ROW_STYLE,
	SIGNOFF_DATA_CELL_LAST_STYLE,
	SIGNOFF_DATA_CELL_STYLE,
	SIGNOFF_HEADER_CELL_LAST_STYLE,
	SIGNOFF_HEADER_CELL_STYLE,
	SIGNOFF_ROW_STYLE,
	SIGNOFF_TABLE_STYLE
} from './blueprint-signoff-table.styles';
import { EditableText } from './editable-text';

export type BlueprintSignoffTableProps = {
	/** Per-sheet override key prefix from getPageOverrideScope — sign-off is signed per sheet, not per design. */
	scope: string;
};

export const BlueprintSignoffTable = (props: BlueprintSignoffTableProps): React.ReactElement => {
	const { scope } = props;

	return (
		<table style={SIGNOFF_TABLE_STYLE}>
			<thead>
				<tr>
					<EditableText overrideKey={`signoff.${scope}.header.dept`} element='th' style={SIGNOFF_HEADER_CELL_STYLE}>Dept.</EditableText>
					<EditableText overrideKey={`signoff.${scope}.header.initials`} element='th' style={SIGNOFF_HEADER_CELL_STYLE}>Initials</EditableText>
					<EditableText overrideKey={`signoff.${scope}.header.date`} element='th' style={SIGNOFF_HEADER_CELL_LAST_STYLE}>Date</EditableText>
				</tr>
			</thead>
			<tbody>
				<tr style={SIGNOFF_ROW_STYLE}>
					<EditableText overrideKey={`signoff.${scope}.casting.dept`} element='td' style={SIGNOFF_DATA_CELL_STYLE}>Casting</EditableText>
					<EditableText overrideKey={`signoff.${scope}.casting.initials`} element='td' style={SIGNOFF_DATA_CELL_STYLE}></EditableText>
					<EditableText overrideKey={`signoff.${scope}.casting.date`} element='td' style={SIGNOFF_DATA_CELL_LAST_STYLE}></EditableText>
				</tr>
				<tr style={SIGNOFF_ALT_ROW_STYLE}>
					<EditableText overrideKey={`signoff.${scope}.processing.dept`} element='td' style={SIGNOFF_DATA_CELL_STYLE}>Processing</EditableText>
					<EditableText overrideKey={`signoff.${scope}.processing.initials`} element='td' style={SIGNOFF_DATA_CELL_STYLE}></EditableText>
					<EditableText overrideKey={`signoff.${scope}.processing.date`} element='td' style={SIGNOFF_DATA_CELL_LAST_STYLE}></EditableText>
				</tr>
				<tr style={SIGNOFF_ROW_STYLE}>
					<EditableText overrideKey={`signoff.${scope}.crating.dept`} element='td' style={SIGNOFF_DATA_CELL_STYLE}>Crating</EditableText>
					<EditableText overrideKey={`signoff.${scope}.crating.initials`} element='td' style={SIGNOFF_DATA_CELL_STYLE}></EditableText>
					<EditableText overrideKey={`signoff.${scope}.crating.date`} element='td' style={SIGNOFF_DATA_CELL_LAST_STYLE}></EditableText>
				</tr>
				<tr style={SIGNOFF_ALT_ROW_STYLE}>
					<EditableText overrideKey={`signoff.${scope}.final.dept`} element='td' style={SIGNOFF_DATA_CELL_STYLE}>Final</EditableText>
					<EditableText overrideKey={`signoff.${scope}.final.initials`} element='td' style={SIGNOFF_DATA_CELL_STYLE}></EditableText>
					<EditableText overrideKey={`signoff.${scope}.final.date`} element='td' style={SIGNOFF_DATA_CELL_LAST_STYLE}></EditableText>
				</tr>
			</tbody>
		</table>
	);
};
